module.exports = __webpack_public_path__ + "static/img/card1.46a356a8.svg";